import React, { Fragment } from 'react';
import { BRAND_NAME } from '../../constants';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { IconButton, Box } from '@material-ui/core';
import { connect } from 'react-redux';
import projectLogo from '../../../assets/images/logo.svg';
import LogoText from './logo_text';
import { motion } from "framer-motion";

const HeaderLogo = props => {
  const { sidebarToggle, sidebarHover } = props;
  return (
    <Fragment>
      <div
        className={clsx('app-header-logo', {
          'app-header-logo-close': sidebarToggle,
          'app-header-logo-open': sidebarHover
        })}>
        <Box
          className="header-logo-wrapper"
          title="Eebac">
          <Link to="/" className="header-logo-wrapper-link">
            <motion.div
              animate={{
                scale: [0, 1],
                rotate: [0, 0, 270, 270, 0],
                borderRadius: ["20%", "20%", "50%", "50%", "20%"]
              }}
              exit="in"
              transition={{
                duration: 1,
                ease: "easeInOut",
              }}>
              <IconButton
                color="primary"
                size="medium"
                className="header-logo-wrapper-btn bg-white">
                <img
                  className="app-header-logo-img"
                  alt={BRAND_NAME}
                  src={projectLogo}
                />
              </IconButton>
            </motion.div>
          </Link>
          <LogoText />
        </Box>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarHover: state.ThemeOptions.sidebarHover
});

export default connect(mapStateToProps)(HeaderLogo);
